import {
  IncomingDocumentRejectionReason,
  IncomingDocumentReviewReason,
  IncomingDocumentType,
  IncomingDocumentStatus,
} from 'src/types/enums';

import { PillColor } from '../../../components/pill/Pill';

export const IncomingDocumentApprovalModeToText = {
  automatic: 'Automatisch',
  manual: 'Handmatig',
} as const;

export const IncomingDocumentStatusToText: Record<IncomingDocumentStatus, string> = {
  [IncomingDocumentStatus.New]: 'Nieuw',
  [IncomingDocumentStatus.Pending]: 'In Behandeling',
  [IncomingDocumentStatus.Approved]: 'Goedgekeurd',
  [IncomingDocumentStatus.Rejected]: 'Afgekeurd',
};

export const IncomingDocumentStatusToColor: Record<IncomingDocumentStatus, PillColor> = {
  [IncomingDocumentStatus.New]: 'positive',
  [IncomingDocumentStatus.Pending]: 'primary',
  [IncomingDocumentStatus.Approved]: 'neutral',
  [IncomingDocumentStatus.Rejected]: 'negative',
};

export const IncomingDocumentTypeToText: Record<IncomingDocumentType, string> = {
  [IncomingDocumentType.Cmr]: 'CMR',
  [IncomingDocumentType.Invoice]: 'Factuur',
  [IncomingDocumentType.Other]: 'Andere',
  [IncomingDocumentType.TransportOrder]: 'Transport Order',
  [IncomingDocumentType.DeliveryNote]: 'Leverbon',
  [IncomingDocumentType.WeighSlip]: 'Weegbon',
  [IncomingDocumentType.PalletNote]: 'Palletbon',
  [IncomingDocumentType.AnnexII]: 'Annex II',
  [IncomingDocumentType.T1Document]: 'T1-document',
  [IncomingDocumentType.AnnexVII]: 'Annex VII',
};

export const IncomingDocumentRejectionReasonToText: Record<IncomingDocumentRejectionReason, string> = {
  [IncomingDocumentRejectionReason.MissingSignature]: 'Handtekening ontbreekt',
  [IncomingDocumentRejectionReason.WrongCustomer]: 'Verkeerde klant',
  [IncomingDocumentRejectionReason.WrongOrgOnDocument]: 'Verkeerde organisatie',
  [IncomingDocumentRejectionReason.NoOrderReference]: 'Geen dossier-referentie gevonden',
  [IncomingDocumentRejectionReason.WrongDocumentType]: 'Verkeerd documenttype',
  [IncomingDocumentRejectionReason.LowQuality]: 'Onvoldoende kwaliteit',
  [IncomingDocumentRejectionReason.WrongDeliveryAddress]: 'Verkeerd leveradres op het document',
  [IncomingDocumentRejectionReason.NotNeutral]: 'Niet-neutrale CMR (vervoerder-branding zichtbaar)',
};

export const IncomingDocumentReviewReasonToText: Record<IncomingDocumentReviewReason, string> = {
  [IncomingDocumentReviewReason.LowImageQuality]: 'Lage beeldkwaliteit',
  [IncomingDocumentReviewReason.AmbiguousSignature]: 'Onduidelijke handtekening',
  [IncomingDocumentReviewReason.PartialPage]: 'Gedeeltelijke pagina',
  [IncomingDocumentReviewReason.AmbiguousCustomer]: 'Klant niet eenduidig herkend',
  [IncomingDocumentReviewReason.AmbiguousType]: 'Documenttype niet eenduidig',
  [IncomingDocumentReviewReason.AmbiguousBoundary]: 'Onduidelijke documentgrens',
  [IncomingDocumentReviewReason.UnknownType]: 'Documenttype niet herkend',
  [IncomingDocumentReviewReason.NonBusinessType]: 'Geen herkenbaar bedrijfsdocument',
  [IncomingDocumentReviewReason.LowConfidence]: 'Lage betrouwbaarheid van AI-analyse',
  [IncomingDocumentReviewReason.NoOrderMatch]: 'Geen overeenkomstige order gevonden',
  [IncomingDocumentReviewReason.NoAiAnalysis]: 'AI-analyse niet beschikbaar',
  [IncomingDocumentReviewReason.InvoicePolicy]: 'Facturen worden altijd handmatig nagekeken (beleid)',
  [IncomingDocumentReviewReason.MultiDocSplitFailed]:
    'PDF bevat meerdere documenten maar kon niet veilig opgesplitst worden',
  [IncomingDocumentReviewReason.AmbiguousDeliveryAddress]: 'Leveradres niet eenduidig herkend',
};
